/* eslint-disable no-undef */
"use strict";

var utils = require("../utils");
var throttle = require("lodash.throttle");
var paginationObserver = initializeObserver();

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $(".refinement.active").each(function () {
        $(this).removeClass("active");
        var activeDiv = $results.find("." + $(this)[0].className.replace(/ /g, "."));
        activeDiv.addClass("active");
        activeDiv.find("button.title").attr("aria-expanded", "true");
    });

    updateDom($results, ".refinements");
    productSlider();
}

/**
 * Collapse Filters for Search Result Page
 *
 * @return {undefined}
 */
function collapseFilters() {
    var urlParams = new URLSearchParams(window.location.search);
    var prmSize = parseInt(urlParams.size, 10);

    var filterPrms = [];
    while (prmSize > 0) {
        if (urlParams.get("prefn" + prmSize)) {
            filterPrms.push(urlParams.get("prefn" + prmSize));
        }
        prmSize--;
    }

    filterPrms.forEach(function (vx) {
        var v = (vx == "filterColor") ? "colour" : vx;
        if ($(".refinement-" + v + "-attr.d-none button[data-selected=true]").length) {
            $(".refinement.refinement-" + v + " .see-more-button").trigger("click");
        }
    });
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        ".refinements": handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        ".grid-header",
        ".header-bar",
        ".header.page-title",
        ".product-grid",
        ".show-more",
        ".search-result-count",
        ".filter-bar"
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });

    collapseFilters();
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data("url");
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: "GET",
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $("<div>").append($(response));
    var sortOptions = $tempDom.find(".grid-footer").data("sort-options").options;
    sortOptions.forEach(function (option) {
        $("option." + option.id).val(option.url);
    });
}

module.exports = {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(".container-tab").on("click", "button.filter-results", function () {
            $(".refinement-bar, .modal-background").show();
            $(".refinement-bar").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".container.search-results").siblings().attr("aria-hidden", true);
            $(".refinement-bar .close").focus();
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(".container-tab").on("click", ".refinement-bar button.close, .modal-background", function () {
            $(".refinement-bar, .modal-background").hide();
            $(".refinement-bar").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".container.search-results").siblings().attr("aria-hidden", false);
            $(".btn.filter-results").focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $(".refinement-bar, .modal-background").hide();
            $(".refinement-bar").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".container.search-results").siblings().attr("aria-hidden", false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(".container-tab").on("change", "[name=sort-order]", function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger("search:sort", this.value);
            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: "GET",
                success: function (response) {
                    $(".product-grid").empty().html(response);
                    initPriceFilterSlider();
                    var currentPage = window.pages && window.pages.current ? window.pages.current : null;
                    if (currentPage && currentPage.events) {
                        currentPage.refresh();
                    }

                    restartPaginationObserver();

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $(".container-tab").on("click", ".show-more button", function (e) {
            e.stopPropagation();
            e.preventDefault();
            var showMoreUrl = $(this).data("url");

            var currentPage = window.pages && window.pages.current ? window.pages.current : null;
            var $eventTarget = $(this);

            // adds the grid url info for the first page
            if (currentPage && currentPage.events && currentPage.events.clicks.length == 0) {
                pushLoadMoreEvent($eventTarget, $(".permalink").data("grid-url"));
            }

            $.spinner().start();
            $(this).trigger("search:showMore", e);
            $.ajax({
                url: showMoreUrl,
                method: "GET",
                success: function (response) {
                    $(".grid-footer").replaceWith(response);
                    updateSortOptions(response);
                    pushLoadMoreEvent($eventTarget, $eventTarget.data("url"));
                    setupSecondaryImageHover();
                    checkSwatchImages();
                    fillWishlistHeartIcons();

                    restartPaginationObserver();

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(".container-tab").on(
            "click",
            ".refinements li button, .visual-refinebar button, .refinement-bar button.reset, .filter-value button, .swatch-filter button",
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger("search:filter", e);
                var attributeId = "#" + $(this).find("span").last().attr("id");
                const selectedUrl = $(this).data("href");
                const baseUrl = new URL(this.baseURI);
                // Remove all search parameters from baseUrl
                baseUrl.search = "";
                const url = new URL(selectedUrl, baseUrl);

                // Append search parameters from selectedUrl to baseUrl
                url.searchParams.forEach((value, key) => {
                    baseUrl.searchParams.set(key, value);
                });

                const queryParamValue = url.searchParams.get("cgid");
                if (queryParamValue) {
                    baseUrl.searchParams.set("category", queryParamValue);
                    baseUrl.searchParams.delete("cgid");
                }
                // Update the URL without reloading the page
                history.pushState(null, null, baseUrl.toString());
                $.ajax({
                    url: $(this).data("href"),
                    data: {
                        page: $(".grid-footer").data("page-number"),
                        selectedUrl: $(this).data("href")
                    },
                    method: "GET",
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                        var currentPage = window.pages && window.pages.current ? window.pages.current : null;
                        if (currentPage && currentPage.events) {
                            currentPage.refresh();
                        }
                        $(attributeId).parent("button").focus();

                        restartPaginationObserver();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent("button").focus();
                    }
                });
            })
            // Handle price refinement selection
            .on("change",
                ".refinements [type=\"range\"]",
                function (e) {
                    return updatePriceRefinementUrl($(this), e);
                }
            );

        // Initializes the slider for price filter
        initPriceFilterSlider();
    },
    /**
    * Adds click event listeners to all elements with the class "see-more-button".
    * When a button is clicked, it reveals additional content and hides the button.
    *
    * @returns {void}
    */
    seeMoreButton: function () {
        $(".container-tab").on("click", ".see-more-button", function (event) {
            const buttonSeeMoreID = event.target.id;
            const buttonId = ".col-12." + buttonSeeMoreID;

            // Handle the click event based on the unique buttonId
            $(buttonId).removeClass("d-none");
            $("#" + buttonSeeMoreID).hide();
        });
    },

    showContentTab: function () {
        // Display content results from the search
        $(".container-tab").on("click", ".content-search", function () {
            if ($("#content-search-results").html() === "") {
                getContent($(this), $("#content-search-results"));
            }
        });

        // Display the next page of content results from the search
        $(".container-tab").on("click", ".show-more-content button", function () {
            getContent($(this), $("#content-search-results"));
            $(".show-more-content").remove();
        });
    },

    quickViewButton: function () {
        $(document).ready(function () {
            var $quickViewButton = $(".quickview-disabled");
            if ($quickViewButton.length) {
                $quickViewButton.removeClass("disabled");
            }
        });
    },

    handleInitOrBackBehavior: function () {
        var currentPage = window.pages.current;
        var pageHistory = window.pageHistory;
        var events = currentPage.events;
        var currentRegionIndex;
        var proccessedEventIndex;

        if (history.scrollRestoration) {
            history.scrollRestoration = "manual";
        }

        $(document).on("click", ".product-tile-image-link, .product-tile-name-anchor-link", function (e) {
            e.preventDefault();

            // get data-pid of this element parent with class .product-tile-wrapper
            var clickedPid = $(this).parents(".product-tile-wrapper").data("pid");
            var regionUrl = $(this).parents(".inner-product-grid").data("regionUrl");

            events.setLastClickedProduct(clickedPid);
            events.setLastClickedRegionLink(regionUrl);
            events.setLastScrolledPosition(window.scrollTop);

            window.sessionStorage.setItem("previous_plp", window.location.href);

            pageHistory.replace({ url: regionUrl });
            window.location.href = $(this).attr("href");
        });

        $(document).on("process:loadMore", function () {
            var lastScrollTop = document.documentElement.scrollTop;

            // find the position of the page/tile grids for the product which was clicked when the user navigates back to the PLP
            // this will be used to determine which grids to load when scrolling up/down and ensures the grids will be loaded in the order they appear in the DOM
            currentRegionIndex = events.clicks.findIndex(function (click) {
                return click.value === window.location.href;
            });

            if (currentRegionIndex > -1) {
                proccessedEventIndex = currentRegionIndex;
                var loading = false;

                // throttle the scroll event to prevent multiple calls to lazyLoadTiles
                window.addEventListener("scroll", throttle(function () {
                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                    // check if scrolling is upwards and if the current grid has been loaded succesfully
                    // This ensures the sequence of the grids is maintained when scrolling up and avoid dupliaction of executing the same grid
                    if (scrollTop < lastScrollTop && proccessedEventIndex > 0 && !loading) {
                        var event = events.getClicks("loadMore")[proccessedEventIndex - 1];
                        loading = true;
                        lazyLoadTiles(event, false).then(function () {
                            proccessedEventIndex--;
                            loading = false;
                        });
                    }

                    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
                    events.setLastScrolledPosition(lastScrollTop);
                }, 1000));

                // load the grids after the current grid which was loaded previously, as soon as the page loads
                events.getClicks("loadMore").slice(currentRegionIndex + 1).forEach(function (click) {
                    lazyLoadTiles(click, true);
                });
            }
        });
    }
};

/**
 * Initializes the slider for price filter with start and end range values
 */
function initPriceFilterSlider() {
    var sliderSections = $(".range-slider");

    for (var x = 0; x < sliderSections.length; x++) {
        var sliders = sliderSections[x].getElementsByClassName("slider-bar");

        for (var y = 0; y < sliders.length; y++) {
            if (sliders[y].type === "range") {
                sliders[y].oninput = getRangeValue;
                sliders[y].oninput();
            }
        }
    }
}

/**
 * Updates the range values of price filter range in the price slider
 * and stores the updated values in HTML hidden input field
 */
function getRangeValue() {
    var parent = this.parentNode;
    var slides = parent.getElementsByClassName("slider-bar");

    if (slides.length >= 2) {
        var slide1 = parseFloat(slides[0].value);
        var slide2 = parseFloat(slides[1].value);

        if (slide1 > slide2) { var tmp = slide2; slide2 = slide1; slide1 = tmp; }

        var minRange = parent.getElementsByClassName("range-values-min")[0];
        var maxRange = parent.getElementsByClassName("range-values-max")[0];

        var customrefinementpricemin = parent.getElementsByClassName("customrefinementpricemin")[0];
        var customrefinementpricemax = parent.getElementsByClassName("customrefinementpricemax")[0];

        var currencysymbol = parent.getElementsByClassName("currencysymbol")[0].value;

        minRange.innerHTML = currencysymbol + parseFloat(slide1).toFixed();
        maxRange.innerHTML = currencysymbol + parseFloat(slide2).toFixed();

        customrefinementpricemin.value = slide1;
        customrefinementpricemax.value = slide2;

        var maxValue = $(".range-min").attr("max");
        var minValue = $(".range-min").attr("min");

        var minRangeValue = parseFloat(slides[0].value);
        var maxRangeValue = parseFloat(slides[1].value);

        const range1 = document.querySelector(".slider .progress");
        range1.style.left = ((minRangeValue - minValue) * 100) / (maxValue - minValue) + "%";
        range1.style.right = ((maxRangeValue - maxValue) * 100) / (minValue - maxValue) + "%";
    }
}

/**
 * Updates the price refinement url with new values of pmin and pmax
 */
function updatePriceRefinementUrl($this, event) {
    var url = $this.data("href");
    var pMin = $(".range-slider .customrefinementpricemin").val();
    var pMax = $(".range-slider .customrefinementpricemax").val();

    var params = utils.getQueryStringParams(url); // fetching params array from url

    //updating the params of pmin and pmax
    params.pmin = pMin;
    params.pmax = pMax;

    url = url.split("?")[0]; // fetch url without querystring
    var newUrl = utils.appendParamsToUrl(url, params); // adding the params back with updated values of pmin and pmax
    $this.data("href", newUrl);

    return updateProductGrids($this, event);
}

/**
 * Renders the new products grid content based on the refinement/filter selection
 *
 * @param {Object} jQuery this object/target element
 * @param {Event} event
 */
function updateProductGrids($this, event) {
    event.preventDefault();
    event.stopPropagation();

    $.spinner().start();

    $this.trigger("search:filter", event);
    var $url = $this.data("href");
    $.ajax({
        url: $url,
        data: {
            page: $(".grid-footer").data("page-number"),
            selectedUrl: $url
        },
        method: "GET",
        success: function (response) {
            parseResults(response);
            initPriceFilterSlider();
            $(".search-results-top").addClass("updated-position");
            $(document).trigger("utag:afterRefinementsSelected");
            restartPaginationObserver();
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

function productSlider() {
    $(".product-type-slider").slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 9,
        slidesToScroll: 1,
        prevArrow: false,


        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false,
                    prevArrow: false,
                    autoplay: false // Add this property
                }
            }
        ]
    });
}

/**
 * Change product image to secondary image on hover
 *
 * @return {undefined}
 */
function setupSecondaryImageHover() {
    // Select all product tiles with a secondary image URL
    $(".image-container[data-second-image-url]").each(function () {
        var $productTile = $(this);
        var $primaryImage = $productTile.find("img.tile-image");
        var secondaryImageUrl = $productTile.data("second-image-url");

        // Store the original image URL
        var primaryImageUrl = $primaryImage.attr("src");

        // Preload the secondary image
        var img = new Image();
        img.src = secondaryImageUrl;

        // Add hover event listeners
        $productTile.hover(
            function () {
                // On mouse enter, change to secondary image
                $primaryImage.attr("src", secondaryImageUrl);
            },
            function () {
                // On mouse leave, revert to primary image
                $primaryImage.attr("src", primaryImageUrl);
            }
        );
    });
}

// Call the function to set up the hover effect
$(document).ready(function () {
    setupSecondaryImageHover();
    checkSwatchImages();
    fillWishlistHeartIcons();
    scrollToLastClickedProductTile();
});


function checkSwatchImages() {
    // Select all PLP tiles that contain swatches
    const plpTiles = document.querySelectorAll(".product-tile");

    plpTiles.forEach(tile => {
        // Select all swatches within the current tile
        const swatches = tile.querySelectorAll(".swatch-link");

        swatches.forEach(swatch => {
            const img = swatch.querySelector("img");
            if (img) {
                // Add an event listener for the error event
                img.addEventListener("error", function () {
                    checkImageStatus(img.src, function (is404) {
                        if (is404) {
                            swatch.classList.add("d-none");
                        }
                    });
                });

                // Check if the image is already broken after it has loaded
                img.addEventListener("load", function () {
                    if (!img.complete || img.naturalWidth === 0) {
                        checkImageStatus(img.src, function (is404) {
                            if (is404) {
                                swatch.classList.add("d-none");
                            }
                        });
                    }
                });

                // If the image is already loaded and broken, hide the swatch
                if (img.complete && img.naturalWidth === 0) {
                    checkImageStatus(img.src, function (is404) {
                        if (is404) {
                            swatch.classList.add("d-none");
                        }
                    });
                }
            }
        });
    });
}

/**
* Checks the status of an image URL and determines if it is not found (404).
* 
* This function uses the Fetch API to make a request to the specified URL and 
* invokes the provided callback function with a boolean indicating whether the 
* image was not found (i.e., the response status is 404).
* 
* @param {string} url - The URL of the image to check.
* @param {function} callback - A callback function that is called with a boolean 
* indicating the image's availability. It receives `true` if the image is not found 
* (404), and `false` otherwise.
*/
function checkImageStatus(url, callback) {
    fetch(url)
        .then(response => {
            callback(response.status === 404);
        })
        .catch(() => {
            callback(true);
        });
}

/**
* Checks if a given Product ID (PID) exists within the items of a wishlist.
* 
* @param {Object} wishlistData - The data object representing the wishlist, which contains an array of item IDs.
* @param {string} wishlistPid - The Product ID (PID) to be checked against the wishlist items.
* @returns {boolean} - Returns true if the wishlist contains the specified PID, otherwise false.
*/
function isWishlistPidInItems(wishlistData, wishlistPid) {
    return wishlistData.items.some(item => item === wishlistPid);
}

/**
* Updates the wishlist heart icons on the page based on the wishlist data.
* 
* This function retrieves the wishlist data from a hidden input field on the page,
* attempts to parse it as JSON, and then uses this data to update the display of
* heart icons in the product grid to reflect the items present in the user's wishlist.
* 
* Note: The actual logic to update the heart icons is not implemented in this function.
*/
function fillWishlistHeartIcons() {
    var wishlistDataStringElement = document.querySelector("input[name='wishlistDataString']");
    var wishlistDataString = wishlistDataStringElement ? wishlistDataStringElement.value : null;
    if (wishlistDataString) {
        var wishlistData;
        try {
            wishlistData = JSON.parse(wishlistDataString);
        } catch (e) {
            wishlistData = {};
        }

        if (wishlistData) {
            // fill the heart icons of the grid here
            var wishlistTiles = document.querySelectorAll(".wishlistTile");
            wishlistTiles.forEach(tile => {
                // Get the value of the 'data-wishlistpid' attribute
                var wishlistPid = tile.getAttribute("data-wishlistpid");
                var isInWishlist = isWishlistPidInItems(wishlistData, wishlistPid);

                var icon = tile.querySelector(".icon-heart");
                if (icon && isInWishlist) {
                    icon.classList.remove("icon-heart");
                    icon.classList.add("icon-heart-dark");
                }
            });

        }
    }
}

/**
* Lazy loads product tiles from the given URL
* @param {Object} event - event object containing the URL
* @param {boolean} append - whether to append the tiles to the existing grid
* @param {Object} event.data - additional data
* @param {boolean} event.data.isLoyaltyEnabled - whether loyalty is enabled
* @param {boolean} event.data.isRewardCatalog - whether reward catalog is enabled
* @returns {Promise} a promise that resolves when the tiles have been loaded
*/
function lazyLoadTiles(event, append) {
    if (event.url) {
        var isLoyaltyEnabled = event.data.isLoyaltyEnabled;
        var isRewardCatalog = event.data.isRewardCatalog;

        return Promise.resolve($.ajax({
            url: event.url,
            method: "GET",
            async: false,
            success: function (response) {
                if (isLoyaltyEnabled && isRewardCatalog) {
                    $(".loyalty-item-grid").remove();
                }

                if (append) {
                    $(".grid-footer").replaceWith(response);
                } else {
                    $(".product-grid").prepend($(response).filter(".inner-product-grid"));
                }

                updateSortOptions(response);
            }
        }));
    }

    return Promise.resolve(1);
}

/**
* Finds the last clicked product tile and scrolls to it
* @param {Object} events - Object containing the last clicked product and region link
* @returns {Promise} - Promise that resolves to the product tile element
*/
function scrollToLastClickedProductTile() {
    var currentPage = window.pages.current;
    var events = currentPage.events;
    var urlWithoutParam = "";
    var currentURLwithoutParam = removeQueryParameters(window.location.href);

    if (events.lastClickedRegionLink == null) {
        var previousPLP = window.sessionStorage.getItem("previous_plp");
        events = currentPage.events.getEventsFromURL(previousPLP);
        urlWithoutParam = removeQueryParameters(events.lastClickedRegionLink);
    }

    if (events.lastClickedRegionLink == window.location.href || 
        events.lastClickedRegionLink == validateAndAddParams(window.location.href) ||
        urlWithoutParam == currentURLwithoutParam) {
        var lastClickedProduct = events.lastClickedProduct;
        var selector = ".product-tile-wrapper[data-pid='" + lastClickedProduct + "']";
        var $productTile = $(selector);

        var observer = new MutationObserver(function (mutations) { // eslint-disable-line
            if (document.querySelector(selector)) {
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        if ($productTile.length) {
            var productTileOffset = $productTile.offset().top;
            scrollAnimate(productTileOffset);
        }

        $(document).trigger("process:loadMore");
    }
    window.sessionStorage.deleteItem("previous_plp");
}

/**
* Push load more grid url details to the events object associated with current search/plp page
* The url will be used to load page content asynchronously which was loaded previously.
* @param {Object} $this - jQuery object
* @param {string} showMoreUrl - the URL to show more items
*/
function pushLoadMoreEvent($this, showMoreUrl) {
    // if (!$(".page").data("backToScrollEnabled")) {
    //     return;
    // }

    var currentpage = window.pages.current || {};
    var events = currentpage.events || {};

    if (events.addClick) {
        // tracks click event for load more button
        events.addClick({
            eventName: "loadMore",
            selector: ".show-more",
            value: $(".permalink").data("back-url"),
            url: showMoreUrl,
            data: $this.data()
        });
    }
}

/**
* Animates the page scroll to the given position
* @param {number} position - the position to scroll to
*/
function scrollAnimate(position) {
    $("html, body").animate({
        scrollTop: position
    }, 500);
}

/**
 * Initializes the observer component to be called after an ajax call.
 * @returns 
 */
function initializeObserver() {
    var $infiniteScroll = $("#infiniteScroll");
    if ($infiniteScroll.length) {
        paginationObserver = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                $(".container-tab .show-more button").trigger("click");
            }
        }, {
            root: null, // Use the viewport as the root
            rootMargin: "0px",
            threshold: 1.0 // Trigger when 100% of the target is visible
        });
        paginationObserver.observe($infiniteScroll[0]);
    }
    return paginationObserver;
}

/**
 * restart the observer after the DOM gets updated.
 */
function restartPaginationObserver() {
    var $infiniteScroll = $("#infiniteScroll");
    if ($infiniteScroll.length) {
        paginationObserver.observe($infiniteScroll[0]);
    }
}

/**
 * Validates if the URL has no query parameters, then adds parameters if valid.
 * 
 * @param {string} url - The URL to validate and modify.
 * @returns {string} - The modified URL with added parameters or an error message.
 */
function validateAndAddParams(url) {
    try {
        const parsedUrl = new URL(url);

        // Check if the URL has no query parameters
        if (parsedUrl.search === "") {
            
            // Add the parameters
            parsedUrl.searchParams.set("pmin", "0.00");
            parsedUrl.searchParams.set("prefn1", "isImageUploaded");
            parsedUrl.searchParams.set("prefv1", "true");

            return parsedUrl.toString();
        } else {
            return "URL already has query parameters.";
        }
    } catch (error) {
        return "Invalid URL.";
    }
}

/**
 * Removes all query parameters from a given URL.
 * 
 * @param {string} url - The original URL from which query parameters should be removed.
 * @returns {string} - The URL without any query parameters.
 */
function removeQueryParameters(url) {
    // Create a URL object
    const urlObj = new URL(url);
    
    // Clear the search parameters
    urlObj.search = "";
    
    // Return the URL without query parameters
    return urlObj.toString();
}
